var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDocumentsBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5637 3.6415L12.4025 1.4276C12.2092 1.21675 11.9369 1.11133 11.6557 1.11133H4.61869C4.03886 1.11133 3.56445 1.58573 3.56445 2.16557V17.7595C3.56445 18.3393 4.03886 18.8137 4.61869 18.8137H15.8902C16.4701 18.8137 16.9445 18.3393 16.9445 17.7595V6.48794C16.9445 6.21559 16.8391 5.95203 16.6546 5.75876L14.5724 3.6415H14.5637Z",
    fill: "#13C097"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4219 12.836L14.4219 11.9422C14.4219 11.8317 14.3323 11.7422 14.2219 11.7422L6.84418 11.7422C6.73372 11.7422 6.64418 11.8317 6.64418 11.9422L6.64418 12.836C6.64418 12.9464 6.73372 13.036 6.84418 13.036L14.2219 13.036C14.3323 13.036 14.4219 12.9464 14.4219 12.836Z",
    fill: "#E4FFF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 9.98246L12.4805 9.08867C12.4805 8.97821 12.3909 8.88867 12.2805 8.88867L6.84416 8.88867C6.7337 8.88867 6.64416 8.97821 6.64416 9.08867L6.64416 9.98246C6.64416 10.0929 6.7337 10.1825 6.84416 10.1825L12.2805 10.1825C12.3909 10.1825 12.4805 10.0929 12.4805 9.98246Z",
    fill: "#E4FFF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4297 15.6885L11.4297 14.7947C11.4297 14.6843 11.3401 14.5947 11.2297 14.5947L6.84408 14.5947C6.73362 14.5947 6.64408 14.6843 6.64408 14.7947L6.64408 15.6885C6.64408 15.799 6.73362 15.8885 6.84408 15.8885L11.2297 15.8885C11.3401 15.8885 11.4297 15.799 11.4297 15.6885Z",
    fill: "#E4FFF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6359 5.75788H13.2711C12.7528 5.75788 12.3398 5.33619 12.3398 4.82664V1.35645L16.6359 5.7491V5.75788Z",
    fill: "#A5E9D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentsBg);
export default __webpack_public_path__ + "static/media/ic_documents_bg.3cc7a117fec95ba76d266f13eea5a5cb.svg";
export { ForwardRef as ReactComponent };